import { v4 as uuidv4 } from 'uuid';
export var makeEventParametersResolver = function () {
    var sequence = 0;
    return function () { return ({
        clientEventTimestamp: Date.now(),
        clientUploadTimestamp: Date.now(),
        // eslint-disable-next-line no-plusplus
        sequence: ++sequence, // в новых версиях клиента, sequence генерится на стороне транспорта, sequence тут оставлен для обратной совместимости
        uuid: uuidv4(),
    }); };
};
//# sourceMappingURL=eventParameters.js.map